import { Injectable, Injector } from '@angular/core';
import { MapToServerSideEnum } from 'src/core/decorators/enum/mapto-server-side-enum.decorator';
import { ServerSideEnum } from './server-side-enum.model';

@Injectable({
  providedIn: 'root',
})
@MapToServerSideEnum('TargetSelectionType')
export class TargetSelectionType extends ServerSideEnum {
  User: number;
  Department: number;
  UserGroup: number;

  constructor(injector: Injector) {
    super(injector);
  }
}
